import React from 'react';

export const sortCallback = (a, b) => a.id - b.id;
export const sameFields = ['bottomDistance', 'dbl', 'lensHeight', 'lensWidth'];

export const Loader = () => (
    <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 text-center">
            <p className="retry-payment__loading" style={{ fontSize: '19px' }}><span>Please wait</span><span>.</span><span>.</span><span>.</span></p>
            <div className="fs13 letter-spacing-1 uppercase" style={{ fontSize: '20px' }}>We are fetching order details.</div>
        </div>
    </div>
);

export const OrderError = () => (
    <div className="margin-t20 text-center" style={{ color: '#cc0000', fontFamily: 'Rajdhani-Medium' }}>
        <span className="fs24 inline-block">Order Not Found</span>
        <p className="fs15 padding-t5">Something went wrong !</p>
    </div>
);
